import { useStore } from '@nanostores/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivateBetaScreen } from './PrivateBetaScreen';
import { NoDatabaseScreen } from '~/components/ui/shadcn/components/supabase-manager/NoDatabaseScreen';
import { StorageManager } from '~/components/ui/shadcn/components/supabase-manager/Storage.client';
import { supabaseStore } from '~/lib/stores/supabase';
import { userStore } from '~/lib/stores/user';

const queryClient = new QueryClient();

export const FileStorage = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const featureFlags = useStore(userStore.featureFlags);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (!featureFlags.supabaseManagement) {
    return (
      <PrivateBetaScreen
        icon="i-heroicons:folder-open"
        title="Store and manage files"
        description="Upload, organize, and serve static assets, user uploads, and media files for your application."
      />
    );
  }

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return (
      <NoDatabaseScreen
        icon="i-heroicons:folder-open"
        description="You need a database to view and serve files for your application directly from your project settings."
      />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <StorageManager />
    </QueryClientProvider>
  );
};
